
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype3 as ObiMosfetNtype3Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-3.js';
 
 
 

 
 export const ObiMosfetNtype3 = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-3',
   elementClass: ObiMosfetNtype3Element,
   events: {
     
   }
  });
 
 